import { render } from "./AnswerBlock.vue?vue&type=template&id=4bc4eca0"
import script from "./AnswerBlock.vue?vue&type=script&lang=js"
export * from "./AnswerBlock.vue?vue&type=script&lang=js"
script.render = render

export default script